<template>
    <div class="">
        <p class="text-center expansion-header">
            {{ $t('epdD.gen5') }}
        </p>
        <div >
            <!--
                Regex Code for Refactoring
                Old:
                    Find:  \[\{\{ \((.*) && (.*).name\) \|\| 'N/A' \}\}\] 
                    Replace:  {{ ($1 && $2.name) ? `[${$2.name}]`: '' }}{{ ($1 && $2.tattoo) ? '{' + $2.tattoo + '}': '' }}
                New:
                   Find:  \{\{ \((.*) && (.*).name\) \? `\[\$\{(.*).name\}\]`: '' \}\}\{\{ \((.*) && (.*).tattoo\) \? '\{' \+ (.*).tattoo \+ '\}': '' \}\}
                   Replace: as needed
                
                Note: '{' + X.tattoo + '}' is used because string interpolation throws error in vue compiler
            -->
            <!-- Father -->
            <div class="pdd">
                <div class="pdd">
                    <!-- F4 -->
                    <div class="right" v-if="siress && siress.sires && siress.sires.sires && siress.sires.sires.sires && siress.sires.sires.sires.animalNumber">
                        <div class="set-img">
                            <v-img src="/img/rowdown.png"></v-img> <span @click="redirectToAnimal(siress.sires.sires.sires.animalNumber)">{{ (siress && siress.sires && siress.sires.sires && siress.sires.sires.sires && siress.sires.sires.sires.animalNumber)  || 'N/A'}}</span> {{ (siress && siress.sires && siress.sires.sires && siress.sires.sires.sires && siress.sires.sires.sires.name) ? `[${siress.sires.sires.sires.name}]`: '' }}{{ (siress && siress.sires && siress.sires.sires && siress.sires.sires.sires && siress.sires.sires.sires.tattoo) ? '{' + siress.sires.sires.sires.tattoo + '}': '' }}
                        </div>
                    </div>
                    <!-- F3 -->
                    <div class="center" v-if="siress && siress.sires && siress.sires.sires && siress.sires.sires.animalNumber">
                        <div class="set-img">
                            <v-img src="/img/rowdown.png"></v-img> <span @click="redirectToAnimal(siress.sires.sires.animalNumber)"> {{ (siress && siress.sires && siress.sires.sires && siress.sires.sires.animalNumber) || 'N/A'}} </span> {{ (siress && siress.sires && siress.sires.sires && siress.sires.sires.name) ? `[${siress.sires.sires.name}]`: '' }}{{ (siress && siress.sires && siress.sires.sires && siress.sires.sires.tattoo) ? '{' + siress.sires.sires.tattoo + '}': '' }}
                        </div>
                    </div>
                    <!-- M4 -->
                    <div class="right" v-if="siress && siress.sires && siress.sires.sires && siress.sires.sires.dams && siress.sires.sires.dams.animalNumber">
                        <div class="set-img">
                        <v-img src="/img/rowup.png"></v-img><span @click="redirectToAnimal(siress.sires.sires.dams.animalNumber)">{{ (siress && siress.sires && siress.sires.sires && siress.sires.sires.dams && siress.sires.sires.dams.animalNumber)  || 'N/A'}}</span> {{ (siress && siress.sires && siress.sires.sires && siress.sires.sires.dams && siress.sires.sires.dams.name) ? `[${siress.sires.sires.dams.name}]`: '' }}{{ (siress && siress.sires && siress.sires.sires && siress.sires.sires.dams && siress.sires.sires.dams.tattoo) ? '{' + siress.sires.sires.dams.tattoo + '}': '' }}
                    </div>
                    </div>
                </div>
                <div class="pdd">
                    <div class="left" v-if="siress && siress.sires && siress.sires.animalNumber"> 
                        <div class="set-img">
                            <v-img src="/img/rowdown.png"></v-img> <span @click="redirectToAnimal(siress.sires.animalNumber)">{{ (siress && siress.sires && siress.sires.animalNumber) || 'N/A' }}</span> {{ (siress && siress.sires && siress.sires.name) ? `[${siress.sires.name}]`: '' }}{{ (siress && siress.sires && siress.sires.tattoo) ? '{' + siress.sires.tattoo + '}': '' }}
                        </div>
                    </div>
                </div>
                <div class="pdd">
                    <!-- F4 -->
                    <div class="right" v-if="siress && siress.sires && siress.sires.dams && siress.sires.dams.sires && siress.sires.dams.sires.animalNumber"> 
                        <div class="set-img">
                            <v-img src="/img/rowdown.png"></v-img><span @click="redirectToAnimal(siress.sires.dams.sires.animalNumber)">{{ (siress && siress.sires && siress.sires.dams && siress.sires.dams.sires && siress.sires.dams.sires.animalNumber)  || 'N/A'}}</span> {{ (siress && siress.sires && siress.sires.dams && siress.sires.dams.sires && siress.sires.dams.sires.name) ? `[${siress.sires.dams.sires.name}]`: '' }}{{ (siress && siress.sires && siress.sires.dams && siress.sires.dams.sires && siress.sires.dams.sires.tattoo) ? '{' + siress.sires.dams.sires.tattoo + '}': '' }}
                        </div>
                    </div>

                    <!-- M3 -->
                    <div class="center" v-if="siress && siress.sires && siress.sires.dams && siress.sires.dams.animalNumber">
                        <div class="set-img">
                            <v-img src="/img/rowup.png"></v-img><span @click="redirectToAnimal(siress.sires.dams.animalNumber)">{{ (siress && siress.sires && siress.sires.dams && siress.sires.dams.animalNumber) || 'N/A' }} </span> {{ (siress && siress.sires && siress.sires.dams && siress.sires.dams.name) ? `[${siress.sires.dams.name}]`: '' }}{{ (siress && siress.sires && siress.sires.dams && siress.sires.dams.tattoo) ? '{' + siress.sires.dams.tattoo + '}': '' }}
                        </div>
                    </div>

                    <!-- M4 -->
                    <div class="right" v-if="siress && siress.sires && siress.sires.dams && siress.sires.dams.dams && siress.sires.dams.dams.animalNumber"> 
                        <div class="set-img">
                            <v-img src="/img/rowup.png"></v-img><span @click="redirectToAnimal(siress.sires.dams.dams.animalNumber)">{{ (siress && siress.sires && siress.sires.dams && siress.sires.dams.dams && siress.sires.dams.dams.animalNumber)  || 'N/A'}}</span> {{ (siress && siress.sires && siress.sires.dams && siress.sires.dams.dams && siress.sires.dams.dams.name) ? `[${siress.sires.dams.dams.name}]`: '' }}{{ (siress && siress.sires && siress.sires.dams && siress.sires.dams.dams && siress.sires.dams.dams.tattoo) ? '{' + siress.sires.dams.dams.tattoo + '}': '' }}
                        </div>
                    </div>
                </div>
            </div>
            <!-- Current Animal -->
            <div class="title-page" v-if="siress && siress.animalNumber"><span class="font-weight-bold mr-1 black--text">{{ $t('animal.sire') }}: </span><span @click="redirectToAnimal(siress.animalNumber)"> {{ siress && siress.animalNumber || 'N/A'}}</span> {{ (siress && siress.name) ? `[${siress.name}]`: '' }}{{ (siress && siress.tattoo) ? '{' + siress.tattoo + '}': '' }}</div>
            <!-- Mother -->
            <div class="pdd">
                <!-- F3 -->
                <div class="pdd">

                    <!-- F4 -->
                    <div class="right" v-if="siress && siress.dams && siress.dams.sires && siress.dams.sires.sires && siress.dams.sires.sires.animalNumber">
                        <div class="set-img">
                            <v-img src="/img/rowdown.png"></v-img><span @click="redirectToAnimal(siress.dams.sires.sires.animalNumber)">{{ (siress && siress.dams && siress.dams.sires && siress.dams.sires.sires && siress.dams.sires.sires.animalNumber)  || 'N/A'}}</span> {{ (siress && siress.dams && siress.dams.sires && siress.dams.sires.sires && siress.dams.sires.sires.name) ? `[${siress.dams.sires.sires.name}]`: '' }}{{ (siress && siress.dams && siress.dams.sires && siress.dams.sires.sires && siress.dams.sires.sires.tattoo) ? '{' + siress.dams.sires.sires.tattoo + '}': '' }}
                        </div>
                    </div>

                    <!-- F3 -->
                    <div class="center" v-if="siress && siress.dams && siress.dams.sires && siress.dams.sires.animalNumber">
                        <div class="set-img">
                            <v-img src="/img/rowdown.png"></v-img><span @click="redirectToAnimal(siress.dams.sires.animalNumber)">{{ (siress && siress.dams && siress.dams.sires && siress.dams.sires.animalNumber) || 'N/A'}}</span> {{ (siress && siress.dams && siress.dams.sires && siress.dams.sires.name) ? `[${siress.dams.sires.name}]`: '' }}{{ (siress && siress.dams && siress.dams.sires && siress.dams.sires.tattoo) ? '{' + siress.dams.sires.tattoo + '}': '' }}
                        </div>
                    </div>

                    <!-- M4 -->
                    <div class="right" v-if="siress && siress.dams && siress.dams.sires && siress.dams.sires.dams && siress.dams.sires.dams.animalNumber"> 
                        <div class="set-img">
                            <v-img src="/img/rowup.png"></v-img><span @click="redirectToAnimal(siress.dams.sires.dams.animalNumber)">{{ (siress && siress.dams && siress.dams.sires && siress.dams.sires.dams && siress.dams.sires.dams.animalNumber) || 'N/A' }}</span> {{ (siress && siress.dams && siress.dams.sires && siress.dams.sires.dams && siress.dams.sires.dams.name) ? `[${siress.dams.sires.dams.name}]`: '' }}{{ (siress && siress.dams && siress.dams.sires && siress.dams.sires.dams && siress.dams.sires.dams.tattoo) ? '{' + siress.dams.sires.dams.tattoo + '}': '' }}
                        </div>
                    </div>
                </div>

                <!-- M2 -->
                <div class="left" v-if="siress && siress.dams && siress.dams.animalNumber">
                    <div class="set-img">
                        <v-img src="/img/rowup.png"></v-img><span @click="redirectToAnimal(siress.dams.animalNumber)">{{ (siress && siress.dams && siress.dams.animalNumber) || 'N/A' }}</span> {{ (siress && siress.dams && siress.dams.name) ? `[${siress.dams.name}]`: '' }}{{ (siress && siress.dams && siress.dams.tattoo) ? '{' + siress.dams.tattoo + '}': '' }}
                    </div>
                </div>

                <!-- M3 -->
                <div class="pdd">
                    <!-- F4 -->
                    <div class="right" v-if="siress && siress.dams && siress.dams.dams && siress.dams.dams.sires && siress.dams.dams.sires.animalNumber"> 
                        <div class="set-img">
                            <v-img src="/img/rowdown.png"></v-img><span @click="redirectToAnimal(siress.dams.dams.sires.animalNumber)">{{ (siress && siress.dams && siress.dams.dams && siress.dams.dams.sires && siress.dams.dams.sires.animalNumber) || 'N/A'}}</span> {{ (siress && siress.dams && siress.dams.dams && siress.dams.dams.sires && siress.dams.dams.sires.name) ? `[${siress.dams.dams.sires.name}]`: '' }}{{ (siress && siress.dams && siress.dams.dams && siress.dams.dams.sires && siress.dams.dams.sires.tattoo) ? '{' + siress.dams.dams.sires.tattoo + '}': '' }}
                        </div>
                    </div>
                    <!-- M3 -->
                    <div class="center" v-if="siress && siress.dams && siress.dams.dams && siress.dams.dams.animalNumber">
                        <div class="set-img">
                            <v-img src="/img/rowup.png"></v-img><span @click="redirectToAnimal(siress.dams.dams.animalNumber)">{{ (siress && siress.dams && siress.dams.dams && siress.dams.dams.animalNumber) }}</span> {{ (siress && siress.dams && siress.dams.dams && siress.dams.dams.name) ? `[${siress.dams.dams.name}]`: '' }}{{ (siress && siress.dams && siress.dams.dams && siress.dams.dams.tattoo) ? '{' + siress.dams.dams.tattoo + '}': '' }}
                        </div>
                    </div>

                    <!-- M4 -->
                    <div class="right" v-if="siress && siress.dams && siress.dams.dams && siress.dams.dams.dams && siress.dams.dams.dams.animalNumber"> 
                        <div class="set-img">
                            <v-img src="/img/rowup.png"></v-img><span @click="redirectToAnimal(siress.dams.dams.dams.animalNumber)">{{ (siress && siress.dams && siress.dams.dams && siress.dams.dams.dams && siress.dams.dams.dams.animalNumber) ||  'N/A'}}</span> {{ (siress && siress.dams && siress.dams.dams && siress.dams.dams.dams && siress.dams.dams.dams.name) ? `[${siress.dams.dams.dams.name}]`: '' }}{{ (siress && siress.dams && siress.dams.dams && siress.dams.dams.dams && siress.dams.dams.dams.tattoo) ? '{' + siress.dams.dams.dams.tattoo + '}': '' }}
                        </div>
                    </div>
                </div>
            </div>
        </div>



        <v-divider class="my-10"></v-divider>



        <div >
            <!-- Father -->
            <div class="pdd">
                <div class="pdd">
                    <div class="right" v-if="damss && damss.sires && damss.sires.sires && damss.sires.sires.sirePubId">
                        <div class="set-img">
                            <v-img src="/img/rowdown.png"></v-img> <span  @click="redirectToAnimal(damss.sires.sires.sirePubId)">{{ damss && damss.sires && damss.sires.sires && damss.sires.sires.sirePubId  || 'N/A'}}</span> {{ (damss && damss.sires && damss.sires.sires && damss.sires.sires.sires &&damss.sires.sires.sires.name) ? `[${damss.sires.sires.sires &&damss.sires.sires.sires.name}]`: '' }}{{ (damss && damss.sires && damss.sires.sires && damss.sires.sires.sires &&damss.sires.sires.sires.tattoo) ? '{' + damss.sires.sires.sires &&damss.sires.sires.sires.tattoo + '}': '' }}
                        </div>
                    </div>
                    <div class="center" v-if="damss && damss.sires && damss.sires.sirePubId">
                        <div class="set-img">
                            <v-img src="/img/rowdown.png"></v-img> <span @click="redirectToAnimal(damss.sires.sirePubId)">{{ damss && damss.sires && damss.sires.sirePubId || 'N/A' }} </span> {{ (damss && damss.sires && damss.sires.sires && damss.sires.sires.name) ? `[${damss.sires.sires.name}]`: '' }}{{ (damss && damss.sires && damss.sires.sires && damss.sires.sires.tattoo) ? '{' + damss.sires.sires.tattoo + '}': '' }}
                        </div>
                    </div>
                    <div class="right" v-if="damss && damss.sires && damss.sires.sires && damss.sires.sires.damPubId">
                        <div class="set-img">
                            <v-img src="/img/rowup.png"></v-img><span @click="redirectToAnimal(damss.sires.sires.damPubId)">{{ damss && damss.sires && damss.sires.sires && damss.sires.sires.damPubId  || 'N/A'}}</span> {{ (damss && damss.sires && damss.sires.sires && damss.sires.sires.dams && damss.sires.sires.dams.name) ? `[${damss.sires.sires.dams.name}]`: '' }}{{ (damss && damss.sires && damss.sires.sires && damss.sires.sires.dams && damss.sires.sires.dams.tattoo) ? '{' + damss.sires.sires.dams.tattoo + '}': '' }}
                        </div>
                    </div>
                </div>
                <div class="pdd">
                    <div class="left" v-if="damss && damss.sirePubId"> 
                        <div class="set-img">
                            <v-img src="/img/rowdown.png"></v-img> <span  @click="redirectToAnimal(damss.sirePubId)">{{ damss && damss.sirePubId || 'N/A' }}</span> {{ (damss && damss.sires && damss.sires.name) ? `[${damss.sires.name}]`: '' }}{{ (damss && damss.sires && damss.sires.tattoo) ? '{' + damss.sires.tattoo + '}': '' }}
                        </div>
                    </div>
                    </div>
                <div class="pdd">
                    <!-- F4 -->
                    <div class="right" v-if="damss && damss.sires && damss.sires.dams && damss.sires.dams.sirePubId"> 
                        <div class="set-img">
                            <v-img src="/img/rowdown.png"></v-img><span @click="redirectToAnimal(damss.sirePubId)">{{ damss && damss.sires && damss.sires.dams && damss.sires.dams.sirePubId  || 'N/A'}}</span> {{ (damss && damss.sires && damss.sires.dams && damss.sires.dams.name) ? `[${damss.sires.dams.name}]`: '' }}{{ (damss && damss.sires && damss.sires.dams && damss.sires.dams.tattoo) ? '{' + damss.sires.dams.tattoo + '}': '' }}
                        </div>
                    </div>
                    <!-- M3 -->
                    <div class="center" v-if="damss && damss.sires && damss.sires.damPubId">
                        <div class="set-img">
                            <v-img src="/img/rowup.png"></v-img><span @click="redirectToAnimal(damss.sirePubId)">{{ damss && damss.sires && damss.sires.damPubId || 'N/A' }} </span> {{ (damss && damss.sires && damss.sires.dams && damss.sires.dams.name) ? `[${damss.sires.dams.name}]`: '' }}{{ (damss && damss.sires && damss.sires.dams && damss.sires.dams.tattoo) ? '{' + damss.sires.dams.tattoo + '}': '' }}
                        </div>
                    </div>
                    <!-- M4 -->
                    <div class="right" v-if="damss && damss.sires && damss.sires.dams && damss.sires.dams.damPubId"> 
                        <div class="set-img">
                            <v-img src="/img/rowup.png"></v-img><span @click="redirectToAnimal(damss.sires.dams.damPubId)">{{ damss && damss.sires && damss.sires.dams && damss.sires.dams.damPubId  || 'N/A'}}</span> {{ (damss && damss.sires && damss.sires.dams && damss.sires.dams.name) ? `[${damss.sires.dams.name}]`: '' }}{{ (damss && damss.sires && damss.sires.dams && damss.sires.dams.tattoo) ? '{' + damss.sires.dams.tattoo + '}': '' }}
                        </div>
                    </div>
                </div>
            </div>
            <!-- Current Animal -->
            <!-- M1 -->
            <div class="title-page" v-if="damss && damss.animalNumber"><span class="font-weight-bold mr-1 black--text">{{ $t('animal.dam') }}: </span><span @click="redirectToAnimal(damss.animalNumber)">{{ damss && damss.animalNumber || 'N/A' }}</span> {{ (damss && damss.name) ? `[${damss.name}]`: '' }}{{ (damss && damss.tattoo) ? '{' + damss.tattoo + '}': '' }}</div>
            <!-- Mother -->
            <div class="pdd">
                <div class="pdd">
                    <!-- F4 -->
                    <div class="right" v-if="damss && damss.dams && damss.dams.sires && damss.dams.sires.sirePubId">
                        <div class="set-img">
                            <v-img src="/img/rowdown.png"></v-img><span @click="redirectToAnimal(damss.dams.sires.sirePubId)">{{ damss && damss.dams && damss.dams.sires && damss.dams.sires.sirePubId  || 'N/A'}}</span> {{ (damss && damss.dams && damss.dams.sires && damss.dams.sires.sires && damss.dams.sires.sires.name) ? `[${damss.dams.sires.sires.name}]`: '' }}{{ (damss && damss.dams && damss.dams.sires && damss.dams.sires.sires && damss.dams.sires.sires.tattoo) ? '{' + damss.dams.sires.sires.tattoo + '}': '' }}
                        </div>
                    </div>

                    <!-- F3 -->
                    <div class="center" v-if="damss && damss.dams && damss.dams.sirePubId">
                        <div class="set-img">
                            <v-img src="/img/rowdown.png"></v-img><span @click="redirectToAnimal(damss.dams.sirePubId)">{{ damss && damss.dams && damss.dams.sirePubId || 'N/A' }}</span> {{ (damss && damss.dams && damss.dams.sires && damss.dams.sires.name) ? `[${damss.dams.sires.name}]`: '' }}{{ (damss && damss.dams && damss.dams.sires && damss.dams.sires.tattoo) ? '{' + damss.dams.sires.tattoo + '}': '' }}
                        </div>
                    </div>

                    <!-- M4 -->
                    <div class="right" v-if="damss && damss.dams && damss.dams.sires && damss.dams.sires.damPubId"> 
                        <div class="set-img">
                            <v-img src="/img/rowup.png"></v-img><span @click="redirectToAnimal(damss.dams.sires.damPubId)">{{ (damss && damss.dams && damss.dams.sires && damss.dams.sires.damPubId) || 'N/A' }}</span> {{ (damss && damss.dams && damss.dams.sires && damss.dams.sires.dams && damss.dams.sires.dams.name) ? `[${damss.dams.sires.dams.name}]`: '' }}{{ (damss && damss.dams && damss.dams.sires && damss.dams.sires.dams && damss.dams.sires.dams.tattoo) ? '{' + damss.dams.sires.dams.tattoo + '}': '' }}
                        </div>
                    </div>
                </div>

                <!-- M2 -->
                <div class="left" v-if="damss && damss.damPubId">
                    <div class="set-img">
                        <v-img src="/img/rowup.png"></v-img><span  @click="redirectToAnimal(damss.damPubId)">{{ (damss && damss.damPubId) || 'N/A' }}</span> {{ (damss && damss.dams && damss.dams.name) ? `[${damss.dams.name}]`: '' }}{{ (damss && damss.dams && damss.dams.tattoo) ? '{' + damss.dams.tattoo + '}': '' }}
                    </div>
                </div>

                <div class="pdd">

                    <!-- F4 -->
                    <div class="right" v-if="damss && damss.dams && damss.dams.dams && damss.dams.dams.sirePubId"> 
                        <div class="set-img">
                            <v-img src="/img/rowdown.png"></v-img><span  @click="redirectToAnimal(damss.dams.dams.sirePubId)">{{ (damss && damss.dams && damss.dams.dams && damss.dams.dams.sirePubId) || 'N/A'}}</span> {{ (damss && damss.dams && damss.dams.dams && damss.dams.dams.sires && damss.dams.dams.sires.name) ? `[${damss.dams.dams.sires.name}]`: '' }}{{ (damss && damss.dams && damss.dams.dams && damss.dams.dams.sires && damss.dams.dams.sires.tattoo) ? '{' + damss.dams.dams.sires.tattoo + '}': '' }}
                        </div>
                    </div>

                    <!-- M3 -->
                    <div class="center" v-if="damss && damss.dams && damss.dams.damPubId">
                        <div class="set-img">
                            <v-img src="/img/rowup.png"></v-img><span  @click="redirectToAnimal(damss.dams.damPubId)">{{ (damss && damss.dams && damss.dams.damPubId) || 'N/A' }}</span> {{ (damss && damss.dams && damss.dams.dams && damss.dams.dams.name) ? `[${damss.dams.dams.name}]`: '' }}{{ (damss && damss.dams && damss.dams.dams && damss.dams.dams.tattoo) ? '{' + damss.dams.dams.tattoo + '}': '' }}
                        </div>
                    </div>

                    <!-- M4 -->
                    <div class="right" v-if="damss && damss.dams && damss.dams.dams && damss.dams.dams.damPubId"> 
                        <div class="set-img">
                            <v-img src="/img/rowup.png"></v-img><span  @click="redirectToAnimal(damss.dams.dams.damPubId)">M4- {{ (damss && damss.dams && damss.dams.dams && damss.dams.dams.damPubId) ||  'N/A'}}</span> {{ (damss && damss.dams && damss.dams.dams && damss.dams.dams.dams && damss.dams.dams.dams.name) ? `[${damss.dams.dams.dams.name}]`: '' }}{{ (damss && damss.dams && damss.dams.dams && damss.dams.dams.dams && damss.dams.dams.dams.tattoo) ? '{' + damss.dams.dams.dams.tattoo + '}': '' }}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import EPDService from "@/_services/EPDService";
import loadingMixin from "@/mixins/LoadingMixin";

export default {
    mounted() {
        this.startLoading();
        EPDService.getSingleEpdInfo(this.$route.params.geneticid, 'pedigree')
        .then(({data}) => {
            // console.log('aaa', data.list)
            this.siress = data.list.sires
            this.damss = data.list.dams
        })
        .catch(e => {
            console.log('err', e)
        })
        .finally(() => {
            this.stopLoading();
        })
    },
    data() {
        return {
            siress: null,
            damss: null,
            siresss: {
                animalNumber: "ANI000020832191",
                name: "AC Animal",
                sirePubId: "19acad29-dfc6-482b-8d43-f63bba70751d",
                damPubId: "ANI000017962717",
                sires: {
                    id: 9,
                    animalNumber: "19acad29-dfc6-482b-8d43-f63bba70751d",
                    name: "DGSDF",
                    sirePubId: "5c1bc027-2f37-4967-8981-08bd6aeebd31",
                    damPubId: "783f74ec-8326-41dc-b175-3827e5d609b7",
                    sires: {
                        id: 8,
                        animalNumber: "5c1bc027-2f37-4967-8981-08bd6aeebd31",
                        name: "hhhgfh",
                        sirePubId: "",
                        damPubId: "783f74ec-8326-41dc-b175-3827e5d609b7",
                        sires: {
                            id: null,
                            animalNumber: null,
                            name: null,
                            sirePubId: null,
                            damPubId: null
                        },
                        dams: {
                            id: 1,
                            animalNumber: "783f74ec-8326-41dc-b175-3827e5d609b7",
                            name: "lukki",
                            sirePubId: "ANI000020832191",
                            damPubId: "783f74ec-8326-41dc-b175-3827e5d609b7"
                        }
                    }
                },
                dams: {
                    id: 17,
                    animalNumber: "ANI000017962717",
                    name: "JDHAB",
                    sirePubId: "19acad29-dfc6-482b-8d43-f63bba70751d",
                    damPubId: "783f74ec-8326-41dc-b175-3827e5d609b7",
                    sires: {
                        id: 9,
                        animalNumber: "19acad29-dfc6-482b-8d43-f63bba70751d",
                        name: "DGSDF",
                        sirePubId: "5c1bc027-2f37-4967-8981-08bd6aeebd31",
                        damPubId: "783f74ec-8326-41dc-b175-3827e5d609b7",
                        sires: {
                            id: 8,
                            animalNumber: "5c1bc027-2f37-4967-8981-08bd6aeebd31",
                            name: "hhhgfh",
                            sirePubId: "",
                            damPubId: "783f74ec-8326-41dc-b175-3827e5d609b7"
                        },
                        dams: {
                            id: 1,
                            animalNumber: "783f74ec-8326-41dc-b175-3827e5d609b7",
                            name: "lukki",
                            sirePubId: "ANI000020832191",
                            damPubId: "783f74ec-8326-41dc-b175-3827e5d609b7"
                        }
                    }
                }
            }
        }
    },
    methods: {
        redirectToAnimal(animalNumber) {
            if(animalNumber) {
                const routeData = this.$router.resolve({name: 'SingleAnimalEpd', params: {geneticid: animalNumber}});
                window.open(routeData.href, '_blank');
            }
        }
    },
    mixins: [loadingMixin]
}
</script>
<style scoped>
.expansion-header {
    border: 1px solid #FFB443 !important; 
    background-color: #FFF7EC !important;
    min-height: 50px;
    border-radius: 5px;
    vertical-align: middle;
    padding: 10px;
    color: #787878;
    font-weight:400;
 }
 .vertical-center {
    margin: 0;
    position: absolute;
    top: 50%;
    -ms-transform: translateY(-50%);
    transform: translateY(-50%);
}
.set-img {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 8px 0px;
    justify-content: center;
    color: #666666;
    font-size: 14px;
}
.set-img .v-image.v-responsive.theme--light {
    max-width: 85px !important;
}
.right .set-img {
    justify-content: left;
    margin: 0px 0px 0px 42%;
    white-space: nowrap;
}
.left .set-img {
    margin: 0px 0px 0px 123px;
    justify-content: left;
}
.center .set-img {
    margin: 0px 0px 0px 30%;
    white-space: nowrap;
    justify-content: left;
}
.set-img .v-image__image--cover {
    background-size: contain;
}
.set-img span {
    color: #00BD73;
    cursor: pointer;
}

.title-page span {
    color: #00BD73;
    cursor: pointer;
    font-size: 1.5em;
}

.invisible {
    visibility: hidden;
}
</style>